import React from 'react'
import GuiaPreenchimento from '../../../components/performance/GuiaPreenchimento'

export default function GuiaPage() {
  return (
    
            <GuiaPreenchimento />
          
  )
}
